export default __webpack_public_path__ + "static/10-69e5cf7e16a9acd1334cd43ed3d46f40.jpg";